export default __webpack_public_path__ + "static/house4-eed44ec3a7d06990b6feafbac05c7916.png";